import { ConfluenceTemplateDetailsRelayPage } from "src/pages/software/confluence/templates/confluence-template-details-contentful-relay-page";

import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import { init as initRelay } from "../init-relay";
import {
    ConfluenceTemplateDetailsRelayPageQuery,
    getConfluenceTemplateDetailsRelayPageQueryVars
} from "../templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-template-details-contentful-relay-page.template";

initRelay(
    ConfluenceTemplateDetailsRelayPage,
    ConfluenceTemplateDetailsRelayPageQuery,
    getConfluenceTemplateDetailsRelayPageQueryVars(window.location),
    RELAY_API_CONTENTFUL
);
